import React, { useEffect, useState } from "react";
import { Switch, useParams } from "react-router-dom";
import { Row, Col, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import SideMenu from "../../components/AccountSideMenu/SideMenu";
import RouteWithSubRoutes from "../../router/RouteWithSubRoutes";
import LocalStorageService from "../../services/LocalStorageService";
import { fetchAccountById } from "../../store/slices/accounts";
import { checkIsLoaded } from "../../lib/utils/checkLoadingStatus";
import BalanceInfo from "../../components/BalanceInfo/BalanceInfo";
import { AccountContainerContext } from "./AccountContainerContext";
import { hasLocalAccessNode } from "../../lib/configs";
import { fetchResponsibleUsers } from "../../store/slices/accountsTs";

const styles = {
  container: {
    display: "flex",
    alignItems: "flex-start",
    paddingBottom: "20px",
  },
  detailsContainer: {
    padding: "10px 10px",
    flex: "1 0 auto",
  },
};

const AccountContainer = (props) => {
  const dispatch = useDispatch();
  const { accountId } = useParams();
  const { account, accountLoading } = useSelector((state) => state.accounts);
  const [isMinimized, setIsMinimized] = useState();
  const [isIndividual, setIsIndividual] = useState(false);

  const accountName = account.individual
    ? [account.individual?.lastName, account.individual?.firstName, account.individual?.middleName]
        .filter(Boolean)
        .join(" ")
    : account.organization?.fullName;

  useEffect(() => {
    dispatch(fetchAccountById({ id: accountId }));
  }, [accountId, dispatch]);

  useEffect(() => {
    setIsMinimized(Number(LocalStorageService.getObject("isMinimizedSideMenu")));
  }, []);

  useEffect(() => {
    if (checkIsLoaded(accountLoading)) {
      setIsIndividual(account.individual !== null);
    }
  }, [accountLoading]);

  const handleClickMinimizeButton = (state) => {
    LocalStorageService.setObject("isMinimizedSideMenu", state);
    setIsMinimized(state);
  };

  return (
    <>
      {checkIsLoaded(accountLoading) ? (
        <Row gutter={[10]} style={{ minHeight: "calc(92vh - 49px)" }} wrap={false}>
          <Col style={{ position: "sticky", top: "64px" }}>
            <SideMenu
              accountName={accountName}
              isMinimized={isMinimized}
              handleClickMinimizeButton={handleClickMinimizeButton}
            />
            {isMinimized ? null : hasLocalAccessNode("account.balanceInfo", <BalanceInfo />)}
          </Col>
          <Col flex={1} style={{ width: "1140px" }}>
            <div className="container_height" style={styles.detailsContainer}>
              <AccountContainerContext.Provider value={{ isIndividual }}>
                <Switch>
                  {/* eslint-disable-next-line react/destructuring-assignment */}
                  {props.routes.map((route) => (
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    <RouteWithSubRoutes key={route.path} {...route} />
                  ))}
                </Switch>
              </AccountContainerContext.Provider>
            </div>
          </Col>
        </Row>
      ) : (
        <Spin className="spin" />
      )}
    </>
  );
};

export default AccountContainer;
